var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _c('main', [_c('div', {
    staticClass: "px-3"
  }, [_c('h2', {
    staticClass: "section-title mt-4"
  }, [_vm._v("預選清單")]), _c('p', {
    staticClass: "total-quantity"
  }, [_vm._v("您的預選單共計"), _c('span', {
    staticClass: "total-quantity--emphasis"
  }, [_vm._v(_vm._s(_vm.totalQuantity))]), _vm._v("項商品")]), _c('div', {
    staticClass: "products"
  }, _vm._l(_vm.formattedSkusInCart, function (sku) {
    return _c('div', {
      key: sku.id,
      staticClass: "products__item"
    }, [_c('img', {
      staticClass: "products__item__photo",
      attrs: {
        "src": sku.image
      }
    }), _c('div', {
      staticClass: "products__item__title"
    }, [_vm._v(" " + _vm._s(sku.title) + " ")]), _vm.priceIsVisible ? _c('div', {
      staticClass: "products__item__price"
    }, [sku.is_discounted ? [_c('span', {
      staticClass: "promoting"
    }, [_vm._v("$" + _vm._s(_vm.applyThousandsSeperator(sku.discounted_price)))]), _c('span', {
      staticClass: "original-price ml-2"
    }, [_vm._v("$ " + _vm._s(_vm.applyThousandsSeperator(sku.original_price)))])] : _c('div', [_vm._v("$" + _vm._s(_vm.applyThousandsSeperator(sku.original_price)))])], 2) : _vm._e(), _vm.pointIsVisible ? _c('div', {
      staticClass: "products__item__price"
    }, [_c('span', {
      staticClass: "price"
    }, [_vm._v(_vm._s(sku.point) + " 點")])]) : _vm._e(), _c('div', {
      staticClass: "products__item__description",
      domProps: {
        "innerHTML": _vm._s(sku.description)
      }
    }), _c('div', {
      staticClass: "products__item__quantity"
    }, [_c('b-form-spinbutton', {
      class: {
        'increment-disabled': _vm.cannotAddMoreQuantity(sku)
      },
      attrs: {
        "size": "sm",
        "inline": "",
        "value": _vm.cart[sku.id],
        "min": "1"
      },
      on: {
        "change": function change(quantity) {
          return _vm.handleSkuQuantityChange(sku.id, quantity);
        }
      }
    })], 1)]);
  }), 0), _c('div', {
    staticClass: "divider mt-4 mb-1"
  }), _vm.priceIsVisible ? _c('div', {
    staticClass: "total-price"
  }, [_vm._v(" TOTAL "), _c('span', {
    staticClass: "total-price--emphasis ml-3 mr-2"
  }, [_vm._v(" " + _vm._s(_vm.applyThousandsSeperator(_vm.totalPrice)) + " ")]), _vm._v(" 元 ")]) : _vm._e(), _vm.pointIsVisible ? _c('div', {
    staticClass: "total-price"
  }, [_vm._v(" TOTAL "), _c('span', {
    staticClass: "total-price--emphasis ml-3 mr-2"
  }, [_vm._v(" " + _vm._s(_vm.applyThousandsSeperator(_vm.totalPoints)) + " ")]), _vm._v(" 點 ")]) : _vm._e(), _vm.terms !== null ? _c('div', {
    staticClass: "preorder-cart__terms mt-4",
    domProps: {
      "innerHTML": _vm._s(_vm.terms)
    }
  }) : _vm._e()]), _vm.topImageUrl ? _c('img', {
    staticClass: "w-100 mt-4",
    attrs: {
      "src": _vm.topImageUrl
    }
  }) : _vm._e(), _c('div', {
    staticClass: "px-3"
  }, [_vm.branchId ? _c('h2', {
    staticClass: "shop-name mt-4"
  }, [_vm._v(_vm._s(_vm.deepGet(_vm.branch, 'name')))]) : _vm._e(), _c('h2', {
    staticClass: "section-title mt-4"
  }, [_vm._v("個人資料")]), _c('div', {
    staticClass: "dynamic-form mt-4"
  }, [_c('DynamicForm', {
    ref: "checkoutForm",
    attrs: {
      "input-subjects": _vm.fields
    },
    model: {
      value: _vm.inputForm,
      callback: function callback($$v) {
        _vm.inputForm = $$v;
      },
      expression: "inputForm"
    }
  })], 1)]), _vm.bottomImageUrl ? _c('img', {
    staticClass: "w-100 mt-4",
    attrs: {
      "src": _vm.bottomImageUrl
    }
  }) : _vm._e()]), _c('footer', {
    staticClass: "sticky-bottom footer-action-bar"
  }, [_c('ShareButton', {
    staticClass: "footer-action-bar__checkout-button",
    attrs: {
      "variant": "s-btn-outline-primary bg-transparent"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'LiffPreorderProducts',
          query: {
            branch_id: _vm.branchId
          }
        });
      }
    }
  }, [_vm._v(" 返回前頁 ")]), _c('ShareButton', {
    staticClass: "footer-action-bar__checkout-button",
    attrs: {
      "variant": "primary",
      "disabled": _vm.totalQuantity === 0 || _vm.isPointMode && _vm.totalPoints > _vm.memberPoints
    },
    on: {
      "click": _vm.handleSubmitButtonClicked
    }
  }, [_vm._v(" 送出訂單 ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }